import type { RegisteredEditorModule } from '../../types';
import {
  createTraditionalCrossword,
  getTraditionalClues,
  saveTraditionalClues,
} from '../../../../../services/admin';
import { emptyTraditionalDoc, type TraditionalDoc } from './doc';
import { traditionalReducer, type TraditionalAction } from './reducer';
import { validate } from './validate';
import { coalesceKeyFor, initialTraditionalUi } from './ui';
import { docToCluesBody, docToCreatePayload, importToDoc, sourceToDoc } from './wire';
import { Canvas } from './Canvas';
import { Inspector } from './Inspector';

// Cruzada tradicional (dicas numa lista, não nas casas): só se editam as DICAS. Não há
// "novo" (a grade vem do gerador/import) nem prévia. Alcançada pelos estilos 1, 2, 4 e
// pelos passatempos legados sem estilo (null); "Regerar" continua valendo no catálogo.

export const traditionalModule: RegisteredEditorModule<TraditionalDoc, TraditionalAction> = {
  kind: 'crossword-traditional',
  label: 'Cruzada tradicional',

  entry: {
    catalog: 'passatempo',
    estilosDePassatemposIds: [1, 2, 4, null],
    keepsRegenerate: true,
    editLabel: 'Editar dicas',
  },

  createEmpty: () => emptyTraditionalDoc(),
  initialUi: () => initialTraditionalUi,
  reduce: traditionalReducer,
  validate,
  coalesceKey: coalesceKeyFor,

  load: (id) => getTraditionalClues(id).then((src) => ({ doc: sourceToDoc(src), editavel: true })),

  save: (id, doc) =>
    id == null
      ? createTraditionalCrossword(docToCreatePayload(doc)).then(({ id: novo }) => ({ id: novo, indices: {} }))
      : saveTraditionalClues(id, docToCluesBody(doc)).then(({ id: salvo }) => ({ id: salvo, indices: {} })),

  import: { kind: 'crossword-traditional', toDoc: importToDoc },

  Canvas,
  Inspector,
};
